import { TextField, useDataProvider } from "react-admin";
import * as React from "react";
import PropTypes from "prop-types";
import { RemarkTypes } from "../../../Enums/RemarkTypes";

const PbhNotesFiled = ({ source = "id", record, label, link }) => {
  const [data, setData] = React.useState<any>({ remark: null });
  const [tempRecordData, setTempRecordData] = React.useState("");
  const dataProvider = useDataProvider();
  React.useEffect(() => {
    if ((data?.remark == null || tempRecordData !== record[source]) && record !== null && record[source] != null) {
      dataProvider
        .getList("PbhRequestRemarks", {
          pagination: { page: 1, perPage: 100 },
          sort: { field: "id", order: "ASC" },
          filter: {
            requestId__eq: record[source],
            remarkType__eq: RemarkTypes.PbhNote,
          },
        })
        .then(result => {
          if (result?.data?.length > 0) {
            var joinedData = result.data.map(x => x.remark).join(", ");
            setData({ remark: joinedData });
          } else {
            setData([]);
          }
        });
    }
    if (tempRecordData !== record[source]) {
      setTempRecordData(record[source]);
    }
  }, [record]);
  return data?.remark != null ? (
    <TextField
      style={{
        width: "100%",
        whiteSpace: "pre-wrap",
        lineBreak: "anywhere",
        minWidth: 200,
      }}
      aria-multiline={"true"}
      component={"pre"}
      sortable={false}
      source={"remark"}
      label={label}
      record={data}
    />
  ) : (
    <></>
  );
};

PbhNotesFiled.propTypes = {
  record: PropTypes.any,
  label: PropTypes.string,
  link: PropTypes.bool,
  source: PropTypes.string,
};

export default PbhNotesFiled;
